import React, { Fragment } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { REEBELO_CURRENCY } from '@lambda/reebelo';
import { isEmpty } from 'lodash-es';
import BackToTopButton from '@/components/collections/BackToTopButton';
import CollectionDefaultSeo from '@/components/collections-v2/common/Collections/CollectionDefaultSeo';
import SeoSection from '@/components/collections-v2/common/SeoSection';
import settings from '@/settings';
import { CollectionLayoutProps } from '../types';
import CollectionBanner from './Banner';

const Marketplace = dynamic(() => import('@/components/commons/Marketplace'));

export default function CollectionLayout(props: CollectionLayoutProps) {
  const router = useRouter();

  // Destructuring
  const {
    pageTitle,
    offers,
    products,
    priceRange,
    children,
    categoryWarrantyInfo,
  } = props;

  const categoryHandle = router.query.handle as string;

  return (
    <Fragment>
      <CollectionDefaultSeo
        title={pageTitle}
        type="navigation"
        priceRange={priceRange}
        currency={REEBELO_CURRENCY[settings.store]}
        productImage={offers?.[0]?.imageSrc}
      />
      <BackToTopButton />
      <div className="bg-white">
        <CollectionBanner
          title={pageTitle}
          categoryWarrantyInfo={categoryWarrantyInfo}
        />
        <div className="reebelo-container pb-8">{children}</div>
        <section className="bg-teal-500 pt-8">
          <Marketplace view="default" />
        </section>
      </div>
      {!isEmpty(props.products) && (
        <div className="reebelo-container pb-14">
          <SeoSection
            handle={categoryHandle}
            pageTitle={pageTitle}
            offers={offers}
            products={products}
            textTitle={pageTitle}
          />
        </div>
      )}
    </Fragment>
  );
}
